import { render } from "./LineSeparator.vue?vue&type=template&id=d0498546"
import script from "./LineSeparator.vue?vue&type=script&lang=ts"
export * from "./LineSeparator.vue?vue&type=script&lang=ts"
script.render = render

export default script